"use client";
import React, { useEffect, useMemo } from "react";
import { Button } from "@/components/ui/button";
import { heroText, subHeroText } from "./contents";
import { openInNewTab } from "@/lib/utils";
import { getCalApi } from "@calcom/embed-react";

type Props = object;

function Hero({}: Props) {
  // Memoize expensive style calculations
  const heroTitleStyle = useMemo(
    () => ({
      background: "linear-gradient(180deg, #F5F5F5 0%, #D0D0D0 100%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      backgroundClip: "text",
    }),
    []
  );
  // text-[clamp(2rem,1.2rem+3vw,4rem)]

  useEffect(() => {
    (async function () {
      const cal = await getCalApi({ namespace: "call-with-pasoma-team" });
      cal("ui", { hideEventTypeDetails: true, layout: "month_view" });
    })();
  }, []);

  return (
    <section className="relative flex min-h-[75vh] w-full items-center justify-center px-4">
      <div className="mx-auto w-full max-w-4xl text-center">
        <h1
          className="text-center text-5xl leading-[1.03125] font-medium tracking-[-0.04em] sm:text-6xl md:text-8xl"
          style={heroTitleStyle}
        >
          {heroText}
        </h1>
        <h3 className="mt-6 text-center text-base leading-relaxed text-zinc-300 sm:text-lg md:text-xl">
          {subHeroText}
        </h3>

        <div className="mx-auto mt-12 w-full max-w-2xl">
          <CTAButtons />
        </div>
      </div>
    </section>
  );
}

export default Hero;

function CTAButtons() {
  return (
    <div className="flex items-center justify-center gap-3">
      <Button
        className="group relative h-12 overflow-hidden rounded-full bg-gradient-to-r from-zinc-200 to-zinc-300 px-5 text-sm text-zinc-900 shadow-lg transition-all duration-300 hover:from-zinc-100 hover:to-zinc-200 hover:shadow-xl md:px-6"
        onClick={() => openInNewTab("https://www.npmjs.com/package/pasoma")}
      >
        <span className="relative z-10 font-medium">Install Pasoma CLI</span>
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
      </Button>
      <Button
        variant="outline"
        className="group relative h-12 overflow-hidden rounded-full border border-zinc-600 bg-transparent px-5 text-sm text-zinc-300 transition-all duration-300 hover:border-zinc-400 hover:bg-zinc-800/50 hover:text-white md:px-6"
        data-cal-namespace="call-with-pasoma-team"
        data-cal-link="faruk-pasoma/call-with-pasoma-team"
        data-cal-config='{"layout":"month_view"}'
      >
        <span className="relative z-10">Schedule a Call</span>
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
      </Button>
    </div>
  );
}
